import { defineStore } from 'pinia'
import { useUserStore } from './useUserStore'
import { useNavItemStore } from './useNavItemStore'
import { useSpyStore } from './useSpyStore'
import { useRecapStore } from './useRecapStore'

export const useStore = defineStore('main', {
  state: () => ({
    user: useUserStore(),
    navItem: useNavItemStore(),
    spy: useSpyStore(),
    recap: useRecapStore(),
    usePageTransition: false,
    iosBrowserSwipingBack: false,
  }),
})

// DO NOT REMOVE
// .quasar/app.js expects a default import
export default {}
